export const mandatoryFields = [
    'arrival_date',
    'booking_date',
    'departure_date',
    'internal_order_id',
];

export default () => {
    return {
        product: [
            'product',
        ],
        consumer: [
            'customer_first_name',
            'customer_last_name',
            'customer_license_plate',
            'customer_phone',
            'customer_remarks',
            'number_of_persons',
            'return_flight_number',
        ],
        financial: [
            'currency',
            'price',
        ],
    };
};



// WEBPACK FOOTER //
// ./src/pages/reservations/list/actions/csv/settings.js